// extracted by mini-css-extract-plugin
export var conainer = "pressNews-module--conainer--b36fd";
export var subcontainer = "pressNews-module--subcontainer--5a9b4";